import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["alignment", "as", "block", "children", "color", "indent", "noWrap", "size", "weight", "classes", "namespace", "display"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
import { cssUtils } from '../CssUtils';
import { displaysMap } from './constants';
import styles from './TextBase.css';
var cx = classNames.bind(styles);
export var TextBase = /*#__PURE__*/forwardRef(function TextBase(_ref, ref) {
  var _ref2;

  var alignment = _ref.alignment,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'p' : _ref$as,
      block = _ref.block,
      children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'N900' : _ref$color,
      indent = _ref.indent,
      noWrap = _ref.noWrap,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      weight = _ref.weight,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      namespace = _ref.namespace,
      display = _ref.display,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'textBase'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cx.apply(void 0, ['root', (_ref2 = {}, _defineProperty(_ref2, "alignment_".concat(alignment), alignment), _defineProperty(_ref2, "".concat(cssUtils("color_".concat(color))), color), _defineProperty(_ref2, "size_".concat(size), size), _defineProperty(_ref2, "weight_".concat(weight), weight), _defineProperty(_ref2, "block", block), _defineProperty(_ref2, "indent", indent), _defineProperty(_ref2, "noWrap", noWrap), _ref2), classes.root].concat(_toConsumableArray(display ? ["display_".concat(displaysMap[display])] : []))),
    ref: ref
  }, getTestId(), rest), children);
});